<script>
import axios from 'axios';
import utilsService from '@/api/utilsService';

const apiUrl = `${process.env.VUE_APP_API_URL}/api/tipos-cambio`;

const getHeaders = () => ({
  'Authorization': `Bearer ${utilsService.getToken()}`,
  'Content-Type': 'application/json',
});

// La clave del registro es la fecha (yyyy-MM-dd), no un Id.
function soloFecha(valor) {
  if (!valor) return '';
  return String(valor).substring(0, 10);
}

function numeroONull(valor) {
  if (valor === '' || valor === null || typeof valor === 'undefined') return null;
  const n = Number(valor);
  return isNaN(n) ? null : n;
}

function buildPayload(formRaw) {
  return {
    fecha: soloFecha(formRaw.fecha),
    clpClp: numeroONull(formRaw.clpClp) || 1,
    usdClp: numeroONull(formRaw.usdClp),
    eurClp: numeroONull(formRaw.eurClp),
    arsClp: numeroONull(formRaw.arsClp),
    copClp: numeroONull(formRaw.copClp),
    penClp: numeroONull(formRaw.penClp),
    audClp: numeroONull(formRaw.audClp),
    usdArs: numeroONull(formRaw.usdArs),
    usdCop: numeroONull(formRaw.usdCop),
    usdPen: numeroONull(formRaw.usdPen),
    audUsd: numeroONull(formRaw.audUsd),
    eurUsd: numeroONull(formRaw.eurUsd),
  };
}

const tipoCambioService = {
  async getAll(desde, hasta) {
    try {
      const params = [];
      if (desde) params.push(`desde=${soloFecha(desde)}`);
      if (hasta) params.push(`hasta=${soloFecha(hasta)}`);
      const url = params.length ? `${apiUrl}?${params.join('&')}` : apiUrl;

      const { data } = await axios.get(url, { headers: getHeaders() });
      return Array.isArray(data) ? data : [];
    } catch (error) {
      throw new Error('Error fetching data: ' + error.message);
    }
  },

  async get(fecha) {
    try {
      const response = await axios.get(`${apiUrl}/${soloFecha(fecha)}`, { headers: getHeaders() });
      return response.data;
    } catch (error) {
      window.location.href = '/error';
    }
  },

  async create(formRaw) {
    try {
      const response = await axios.post(apiUrl, buildPayload(formRaw), { headers: getHeaders() });
      return response;
    } catch (error) {
      if (error && error.response) {
        throw error;
      }
      throw {
        response: {
          status: 0,
          data: (error && error.message) ? error.message : 'Error en la solicitud.',
        },
      };
    }
  },

  async update(formRaw, fecha) {
    try {
      const response = await axios.put(`${apiUrl}/${soloFecha(fecha)}`, buildPayload(formRaw), { headers: getHeaders() });
      return response.status;
    } catch (error) {
      const data = (error && error.response) ? error.response.data : null;
      const msg = (data && data.message) ? data.message : (data || (error && error.message));
      throw new Error(msg || 'Error al actualizar el tipo de cambio.');
    }
  },

  async deleteBy(fecha) {
    try {
      const response = await axios.delete(`${apiUrl}/${soloFecha(fecha)}`, { headers: getHeaders() });
      return response.status;
    } catch (error) {
      const data = (error && error.response) ? error.response.data : null;
      const msg = (data && data.message) ? data.message : (data || (error && error.message));
      throw new Error(msg || 'Error al eliminar el tipo de cambio.');
    }
  },
};

export default tipoCambioService;
</script>
